import UploadDigitalAssetRequestModelBase from '../_generated/modelBases/upload-digital-asset-request-model-base';

export default class UploadDigitalAssetRequestModel extends UploadDigitalAssetRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
